import { fetchAuthSession, JWT } from '@aws-amplify/auth'



export async function getJwtToken() {
	const session = await fetchAuthSession()
	if (!session.tokens) throw new Error('No session tokens for cognito, trying to call')
	if (!session.tokens.idToken) throw new Error("No id token")
	return session.tokens.idToken
}

export function clearJwt(){
	// no-op since we no longer cache it manually
}

